<template>
  <div
    v-if="!loading"
    class="block__block"
    :class="{ chosen: chosen }"
    :style="{ backgroundColor: category.color }"
    :id="time"
  >
    <span class="block-eventStr">
      <span name="message">{{ message }}</span>
      <span class="block__lable">
        <a-icon class="block__check" type="check" />
      </span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["time"],
  data() {
    return {
      loading: true,
      category: {},
      event: {},
      message: "",
      color: "",
      chosen: false
    };
  },
  watch: {
    logs() {
      this.initBlock();
    }
  },
  computed: {
    logs() {
      return this.$store.getters.logs;
    },
    ...mapGetters([
      "setting",
      "selectedBlocks",
      "blocksState",
      "categorys",
      "events"
    ])
  },
  mounted() {
    this.initBlock();
  },
  methods: {
    async initBlock() {
      this.category = Object.freeze(this.getCategory());
      this.event = Object.freeze(this.getEvent());
      this.chosen = Object.freeze(this.getChosen()); //更新区间的时候保留选择状态
      this.color = this.getColor();
      this.message = this.getMessage();
      this.loading = false;
    },
    //当前当前分类
    getCategory() {
      const record = this.blocksState[this.time];
      if (record) {
        return this.categorys[record.category] || {}; //最后的{}是为了处理被删除的记录
      }
      return {};
    },
    //获取当前事件
    getEvent() {
      const log = this.blocksState[this.time];
      if (log && log.event) {
        return this.events[log.event] || {}; //最后的{}是为了处理被删除的记录
      }
      return {};
    },
    getChosen() {
      return this.selectedBlocks[this.time] ? true : false;
    },
    getColor() {
      return this.category.color;
    },
    getMessage() {
      //TODO 优化算法

      //获取当前块信息
      const nowRecord = this.blocksState[this.time];
      if (!this.hasCategory(nowRecord)) return; //如果不存在该分类则提前退出

      //获取前一个块信息
      const prevRecord = this.blocksState[
        this.time - parseInt(this.setting.block.size) * 60 * 1000
      ];

      //获取显示字段配置
      const showFields = this.setting.block.showField;
      if (showFields.length < 1) return ""; //不显示任何一个字段的时候的时候也不要显示省略号

      const keys = ["category", "event", "description"]; //需要对比的属性

      //判断两个块是否相等
      let isEqual = true;
      for (let key of keys) {
        if (
          prevRecord === undefined ||
          nowRecord === undefined ||
          prevRecord[key] !== nowRecord[key]
        ) {
          isEqual = false;
          break;
        }
      }

      if (isEqual) return "...";
      //获取设置
      const strs = [];
      // category.name
      // event.icon
      // event.name
      // event.abbr
      for (let showField of showFields) {
        const [type, field] = showField.split(".");
        if (!nowRecord[type]) continue;

        let str = this[type + "s"][nowRecord[type]][field];
        if (!str) str = "";
        strs.push(str);
      }

      return strs.filter(e => e && e.length > 0).join("-");
    },
    hasCategory(blocksState) {
      return Boolean(blocksState && this.categorys[blocksState.category]);
    }
  }
};
</script>

<style>
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: translate(2rem, 2rem);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes buzz {
  50% {
    transform: translateX(1px) rotate(1deg);
  }
  100% {
    transform: translateX(-1px) rotate(-1deg);
  }
}

.time {
  display: none;
}

.block__day:hover .time {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
}

.block__block {
  background-color: #e6e6e6;
  position: relative;
  padding: 3px 2px;
  color: #fff;
  margin: 1px;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  text-align: center;
  user-select: none;
  transition-duration: 0.5s;
}

.nomargin .block__block {
  margin: 0;
  border-radius: 0;
}

.tran {
  transition-duration: 0.3s;
}

.block__check {
  position: absolute;
  right: 0;
  bottom: 0;
}

span.block__lable {
  display: none;
  position: absolute;
  height: 28px;
  width: 28px;
  background-color: #f2637b;
  opacity: 0.5;
  clip-path: polygon(100% 0, 0 100%, 100% 100%);
  right: 0;
  bottom: 0;
  /* animation: bounce-in .2s; */
}

.chosen .block__lable {
  display: block;
}
</style>
